import { useState } from "react";
import { Field, Formik } from "formik"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import DatePicker from 'react-datepicker'
import { withTranslation } from "react-i18next"
import * as Yup from 'yup';
import { FaExternalLinkAlt } from "react-icons/fa";
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import 'react-phone-input-2/lib/style.css'
import { format } from 'date-fns';

import { useLocation } from "react-router-dom";
import { BAZ_ACCOUNT_ID } from "../../constants/urls";


function StepOne({ t, next, initialData, phoneNumber, tipoSangre, setPhoneNumber, setTipoSangre, company, account, phoneNumber2, setPhoneNumber2 }) {
    const handleSubmit = (values) => {
        next(values)
    }

    // BAZ 
    const location = useLocation();
    const parts = location.pathname.split("/"); 
    const specialtyId = parts[3];
    console.log("Specialty and Account",specialtyId,account?.id)

    const [dateOfBirthday, setDateOfBirthday] = useState(null)

    const curpRegExp = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
    const specialCaseRegExp = /^XXXX999999XXXXXX99$/;

    const shemaValidateStepOne = Yup.object().shape({
        name: Yup.string()
            .required(t('Camporequerido')),
        lastName: Yup.string()
            .required(t('Camporequerido')),
        phoneNumber: Yup.string()
            .required(t('Camporequerido'))
            .min(12, 'Campo invalido')
            .max(12, 'Campo invalido'),
        curp: Yup.string()
            .required(t('Camporequerido'))
            .test('curp', 'Curp invalido', (value) => {
                return curpRegExp.test(value) || specialCaseRegExp.test(value);
            }),
        dateOfBirthday: Yup.string()
            .required(t('Camporequerido')),
        gender: Yup.string()
            .required(t('Camporequerido')),
        email: Yup.string()
            .email(t('Correoinvalido'))
            .required(t('Camporequerido')),
        cardLastDigits: Yup.string().when([], {
            is: () => account?.id === BAZ_ACCOUNT_ID,
            then: Yup.string()
                .matches(/^[0-9]{4}$/, 'Debes ingresar exactamente 4 di­gitos')
                .required('Campo requerido'),
            otherwise: Yup.string().notRequired()
        }),
        aceptarTerminos: Yup.bool().oneOf([true], 'Debes aceptar los terminos y condiciones'),
    });


    return (
        <Formik
            initialValues={initialData}
            validationSchema={shemaValidateStepOne}
            onSubmit={handleSubmit}
        >{({
            errors,
            values,
            handleSubmit,
            setFieldValue,
            setFieldError
        }) => (
            <Form onSubmit={handleSubmit}>
                <Card className="mb-3">
                    <Card.Header className="text-center bg-primary text-white">
                        <h5 className="m-0">{t('informacion_pacientes')}</h5>
                        <p className="m-0 font-size-08rem">{t('step1_mex')}</p>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col xs="12" md="3">
                                <Form.Group>
                                    <Form.Label>{t('Nombre')} <span className="text-danger">*</span></Form.Label>
                                    <Field
                                        type="text"
                                        className={`form-control input-form text-uppercase ${errors.name && 'error'}`}
                                        name="name"
                                        onChange={e => {
                                            setFieldValue('name', e.target.value.toUpperCase())
                                        }}
                                    />
                                    {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="3">
                                <Form.Group>
                                    <Form.Label>Segundo nombre</Form.Label>
                                    <Field
                                        type="text"
                                        className={`form-control input-form text-uppercase`}
                                        name="middleName"
                                        onChange={e => {
                                            setFieldValue('middleName', e.target.value.toUpperCase())
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="3">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">Primer apellido <span className="text-danger">*</span></Form.Label>
                                    <Field
                                        type="text"
                                        className={`form-control input-form text-uppercase ${errors.lastName && 'error'}`}
                                        name="lastName"
                                        onChange={e => {
                                            setFieldValue('lastName', e.target.value.toUpperCase())
                                        }}
                                    />
                                    {errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="3">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">Segundo apellido</Form.Label>
                                    <Field
                                        type="text"
                                        className={`form-control input-form text-uppercase`}
                                        name="seccondSurname"
                                        onChange={e => {
                                            setFieldValue('seccondSurname', e.target.value.toUpperCase())
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">CURP <span className="text-danger">*</span></Form.Label>
                                    <Field
                                        type="text"
                                        className={`form-control input-form text-uppercase ${errors.curp && 'error'}`}
                                        name="curp"
                                        onChange={e => {
                                            setFieldValue('curp', e.target.value.toUpperCase());
                                        }}
                                    />
                                    {errors.curp && <div className="invalid-feedback d-block">{errors.curp}</div>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary d-block">
                                        {t("fecha_nacimiento")} <span className="text-danger">*</span>
                                    </Form.Label>
                                    <DatePicker
                                        className={`form-control input-form w-100 ${errors.dateOfBirthday && 'error'}`}
                                        selected={dateOfBirthday}
                                        dateFormat="dd-MM-yyyy"
                                        maxDate={new Date()}
                                        onChange={date => {
                                            if (date === null) {
                                                setDateOfBirthday(null);
                                                setFieldValue('dateOfBirthday', '');
                                            } else {
                                                const formattedDate = format(date, 'dd-MM-yyyy');
                                                setDateOfBirthday(date);
                                                setFieldValue('dateOfBirthday', formattedDate);
                                            }
                                        }}
                                    />
                                    {errors.dateOfBirthday && <div className="invalid-feedback d-block">{errors.dateOfBirthday}</div>}
                                </Form.Group>
                            </Col>

                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('sexo')} <span className="text-danger">*</span></Form.Label>
                                    <Field
                                        as="select"
                                        className={`form-control input-form ${errors.gender && 'error'}`}
                                        name="gender"
                                    >
                                        <option value="">Seleccione</option>
                                        <option value="Male">{t('Masculino')}</option>
                                        <option value="Female">{t('Femenino')}</option>
                                    </Field>
                                    {errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div>}
                                </Form.Group>
                            </Col>

                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('no_poliza_walmart')}</Form.Label>
                                    <Field
                                        type="text"
                                        className={`form-control input-form ${errors.externalId && 'error'}`}
                                        name="externalId"
                                    />
                                    <Form.Text muted>Este campo no es obligatorio</Form.Text>
                                    {errors.externalId && <div className="invalid-feedback d-block">{errors.externalId}</div>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Correoelectronico')} <span className="text-danger">*</span></Form.Label>
                                    <Field
                                        type="text"
                                        className={`form-control input-form ${errors.email && 'error'}`}
                                        name="email"
                                    />
                                    {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('Telefono_walmart')} <span className="text-danger">*</span></Form.Label>
                                    <PhoneInput
                                        inputClass={`form-control input-form ${errors.phoneNumber && 'error'} w-100`}
                                        country={'mx'}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        preferredCountries={['mx', 'co']}
                                        disableSearchIcon={true}
                                        localization={es}
                                        value={phoneNumber}
                                        onChange={(phone, country, e, formattedValue) => {
                                            setPhoneNumber(phone)
                                            setFieldValue('phoneNumber', phone)
                                            let validNumber = (country.format.match(/\./g)).length
                                            if (phone.length !== validNumber) {
                                                setFieldError('phoneNumber', 'Campo invalido')
                                            } else if (phone.length === validNumber) {
                                                setFieldValue('phoneNumber', phone, true)
                                            }
                                        }}
                                    />
                                    {errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div>}
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">Teléfono alterno</Form.Label>
                                    <PhoneInput
                                        inputClass={`form-control input-form ${errors.phoneNumber2 && 'error'} w-100`}
                                        country={'mx'}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        preferredCountries={['mx', 'co']}
                                        disableSearchIcon={true}
                                        localization={es}
                                        value={phoneNumber2}
                                        onChange={(phone, country, e, formattedValue) => {
                                            setPhoneNumber2(phone)
                                            setFieldValue('phoneNumber2', phone)
                                            let validNumber = (country.format.match(/\./g)).length
                                            if (phone.length !== validNumber) {
                                                setFieldError('phoneNumber2', 'Campo invalido')
                                            } else if (phone.length === validNumber) {
                                                setFieldValue('phoneNumber2', phone, true)
                                            }
                                        }}
                                    />
                                    <Form.Text muted>Este campo no es obligatorio</Form.Text>
                                    {errors.phoneNumber2 && <div className="invalid-feedback d-block">{errors.phoneNumber2}</div>}
                                </Form.Group>
                            </Col>

                            {/* BAZ 4 digitos */}
                            {account?.id === BAZ_ACCOUNT_ID && (
                                <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">
                                        Últimos 4 dígitos de la tarjeta <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            maxLength={4}
                                            className={`form-control input-form ${errors.cardLastDigits && 'error'}`}
                                            value={values.cardLastDigits || ""}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, ""); 
                                                setFieldValue("cardLastDigits", value);

                                                if (value.length !== 4) {
                                                    setFieldError("cardLastDigits", "Debes ingresar 4 di­gitos");
                                                }
                                            }}
                                            placeholder="XXXX"
                                        />
                                        <Form.Text muted>Ingresa solo los Ultimos 4 di­gitos</Form.Text>
                                        {errors.cardLastDigits && (
                                            <div className="invalid-feedback d-block">{errors.cardLastDigits}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                            )}

                            <Col xs="12" md="12">
                                <Form.Group className="text-center">
                                    <Field
                                        type="checkbox"
                                        className={`${errors.aceptarTerminos && 'error'} mr-2`}
                                        name="aceptarTerminos"
                                    />
                                    <Form.Label className="font-weight-bold-600 text-secondary">
                                        <a
                                            href="https://ikeasistencia.com/aviso-legal-y-de-privacidad/"
                                            target="blank"
                                            className="text-primary"
                                        >
                                            {t('aceptar_term_cond_legales')} <FaExternalLinkAlt className="font-size-08rem mb-1" />
                                        </a>
                                    </Form.Label>
                                    {errors.aceptarTerminos && <div className="invalid-feedback d-block">{errors.aceptarTerminos}</div>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-right">
                                <Button type="submit" variant="primary">{t('siguiente')}</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Form>
        )}

        </Formik>
    )

}

export default withTranslation()(StepOne)